import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ListBuildings from "./List";
import { BUILDINGS, AdministrationServicePath } from "utils/constants";
import EditBuildings from "./Edit";
import CreateBuildings from "./Create";
import ShowBuildings from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <AccountBalanceIcon />,
  name: AdministrationServicePath + BUILDINGS,
  title: "Сгради",
  list: <ListBuildings />,
  create: <CreateBuildings />,
  createPermission: permissions.canCreateBuildings,
  edit: <EditBuildings />,
  editPermission: permissions.canUpdateBuildings,
  show: <ShowBuildings />,
  showPermission: permissions.canPreviewBuildings,
  permission: permissions.canPreviewBuildings,
};
